
















import { Component, Vue } from 'vue-property-decorator';
import AppModal from '@/components/AppModal.vue'
import AppBtnGroup from '@/components/AppBtnGroup.vue'
import AppBtn from '@/components/AppBtn.vue';
import AppModalContent from '@/components/AppModalContent.vue';
import Mob from '@/models/Mob';

@Component({
  components: {
    AppModal,
    AppBtn,
    AppBtnGroup,
    AppModalContent
  }
})
export default class SpawnConfirmView extends Vue {
  get spawnId(): string {
    return this.$route.params.spawnId
  }

  get mob(): Mob {
    return this.$store.getters['game/currentMob']
  }

  xpToLevel(xp: number): number {
    return Mob.xpToLevel(xp)
  }
}
